;(function($, undefined) {

    'use strict';

    var rnn = window.rnn;

    function triggerFacebookConversionTracking() {

        var chargifyParams = getChargifyCookieParams();

        if (!_.has(chargifyParams, 'signup_revenue')) {
            return false;
        }

        // See SCRUM-7868
        (function() {
            var _fbq = window._fbq || (window._fbq = []);
            if (!_fbq.loaded) {
                var fbds = document.createElement('script');
                fbds.async = true;
                fbds.src = window.location.protocol + '//connect.facebook.net/en_US/fbds.js';
                var s = document.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(fbds, s);
                _fbq.loaded = true;
            }
        })();

        window._fbq = window._fbq || [];
        // I believe this number is a facebook something account number.
        // I have no idea what I'm doing.
        window._fbq.push(
            ['track', '6030405820086', {'value': chargifyParams.signup_revenue, 'currency': 'AUD'}]
        );
    }

    function redirectToChargify(chargifyURL) {
        window.location = chargifyURL;
    }

    function getChargifyCookieParams() {
        var chargifyParamsCookie = Cookies.get('chargifyParams');

        if (chargifyParamsCookie === undefined) {
            return {};
        }

        try {
            return JSON.parse(chargifyParamsCookie);
        } catch (e) {
            return {};
        }
    }

    function addChargifyEcommerceTransaction() {

        var ua = __apnTrac,
            chargifyParams = getChargifyCookieParams(),
            requiredKeys = [
                'signup_payment_id',
                'signup_revenue',
                'product_handle',
                'product_id'
            ];

        if (!rnn.modules.utilities.hasAllKeys(chargifyParams, requiredKeys)) {
            return false;
        }

        // Load the ecommerce UA plugin.
        ua('require', 'ecommerce');

        // Add a transaction.
        ua('ecommerce:addTransaction', {
            'id': chargifyParams.signup_payment_id,
            'affiliation': 'Chargify subscriptions',
            'revenue': chargifyParams.signup_revenue
        });

        // Add the item to the transaction.
        ua('ecommerce:addItem', {
            'id': chargifyParams.signup_payment_id,
            'name': chargifyParams.product_handle,
            'sku': chargifyParams.product_id
        });

        // Finally send the UA transaction.
        ua('ecommerce:send');
    }

    function successfulSubscriptionAnalytics() {

        // Check for a data attribute indicating a successful chargify subscription.
        // If this happened, then trigger the analytics for this event.
        if ($('[data-chargify-subscription-success=true]').length > 0) {
            addChargifyEcommerceTransaction();
            triggerFacebookConversionTracking();
        }

    }
    function init() {
        successfulSubscriptionAnalytics();
    }

    rnn.modules.register('chargify', {
        'init': init,
        'redirectToChargify': redirectToChargify,
        'getChargifyCookieParams': getChargifyCookieParams
    });

})(jQuery);
